module.exports = __webpack_public_path__ + "img/TALHADEIRA RETA PONTA CUNHA  -mobile.552c4a43.png";